/**
 * Do not edit directly, this file was auto-generated.
 */

module.exports = {
  "brown-12a": "rgba(249, 248, 244, 0.12)",
  "brown-24a": "rgba(249, 248, 244, 0.24)",
  "brown-8a": "rgba(249, 248, 244, 0.08)",
  "brown-90a": "rgba(249, 248, 244, 0.9)",
  "dark-brown-12a": "rgba(135, 121, 111, 0.12)",
  "dark-brown-24a": "rgba(135, 121, 111, 0.24)",
  "dark-brown-4a": "rgba(135, 121, 111, 0.04)",
  "dark-brown-8a": "rgba(135, 121, 111, 0.08)",
  "dark-brown-80a": "rgba(135, 121, 111, 0.8)",
  "purple-12a": "rgba(158, 148, 241, 0.12)",
  "purple-18a": "rgba(158, 148, 241, 0.18)",
  "purple-28a": "rgba(158, 148, 241, 0.28)",
  "purple-4a": "rgba(158, 148, 241, 0.04)",
  "purple-70a": "rgba(158, 148, 241, 0.7)",
  "purple-8a": "rgba(158, 148, 241, 0.08)",
  "red-12a": "rgba(255, 109, 92, 0.12)",
  "red-18a": "rgba(255, 109, 92, 0.18)",
  "red-28a": "rgba(255, 109, 92, 0.28)",
  "red-4a": "rgba(255, 109, 92, 0.04)",
  "red-70a": "rgba(255, 109, 92, 0.7)",
  "red-8a": "rgba(255, 109, 92, 0.08)",
  "blue-50": "#f0f6fe",
  "blue-100": "#dce9fd",
  "blue-200": "#c2dafb",
  "blue-300": "#98c3f8",
  "blue-400": "#67a3f3",
  "blue-500": "#4380ee",
  "blue-600": "#3165e3",
  "blue-700": "#204bb4",
  "blue-800": "#192e75",
  "blue-900": "#121f54",
  "brown-50": "#f9f8f4",
  "brown-100": "#f3efe9",
  "brown-200": "#ede6de",
  "brown-300": "#d4c5ba",
  "brown-400": "#ae9f95",
  "brown-500": "#87796f",
  "brown-600": "#6f635c",
  "brown-700": "#574e48",
  "brown-800": "#3f3835",
  "brown-900": "#272221",
  "purple-50": "#f5f4fe",
  "purple-100": "#ecebfc",
  "purple-200": "#dad9fb",
  "purple-300": "#bfbbf7",
  "purple-400": "#9e94f1",
  "purple-500": "#7e68ea",
  "purple-600": "#664bdd",
  "purple-700": "#4d2dab",
  "purple-800": "#40268c",
  "purple-900": "#26175e",
  "red-50": "#fff2f1",
  "red-100": "#ffe4e2",
  "red-200": "#ffada7",
  "red-300": "#ff8d82",
  "red-400": "#ff6d5c",
  "red-500": "#e85546",
  "red-600": "#d03c2f",
  "red-700": "#a83126",
  "red-800": "#782b24",
  "red-900": "#41120e",
  "teal-50": "#f1fcfb",
  "teal-100": "#d1f6f3",
  "teal-200": "#a3ece8",
  "teal-300": "#6ddbda",
  "teal-400": "#3cbcbe",
  "teal-500": "#25a4a7",
  "teal-600": "#1b8186",
  "teal-700": "#1a6367",
  "teal-800": "#194448",
  "teal-900": "#09252a",
};
